import './instrument';

import React from 'react';
import * as Sentry from '@sentry/react';
import { Root, createRoot } from 'react-dom/client';
import { App } from './App';
import { initClarity } from '@/utils/clarity';

import 'antd/dist/antd.less';

const container = document.getElementById('root') as HTMLElement;
const root: Root = createRoot(container);

initClarity();

root.render(
	<Sentry.ErrorBoundary fallback={<p>Unexpected error.</p>}>
		<App />
	</Sentry.ErrorBoundary>
);
